import React from 'react'
import HowAreYouTodaySkeleton from './HowAreYouTodaySkeleton'
import TasksListSkeleton from './TasksListSkeleton'

/**
 * Whole-widget placeholder used only as the Suspense fallback while the lazy
 * MyTask chunk downloads (small screens). Mirrors MyTask's card layout.
 */
function MyTaskWidgetSkeleton() {
    return (
        <div className="my-tasks-widget relative xxs:w-full xl:w-[480px] flex justify-center h-full" aria-hidden="true">
            <div className="bg-white h-full rounded-xl w-full flex flex-col">
                <div className="w-full flex justify-between items-center">
                    <HowAreYouTodaySkeleton />
                </div>
                <div className="flex items-center mt-5 mx-[35px]">
                    <div className="dsh-skeleton-block h-6 w-[100px]" />
                    <div className="flex-1" />
                    <div className="dsh-skeleton-block h-5 w-[56px]" />
                </div>
                <div className="mt-[10px] mx-[35px]">
                    <div className="dsh-skeleton-block h-4 w-[180px]" />
                </div>
                <div className="mt-5 mx-[35px] h-[1px] border-b border-dashed border-b-lightBG" />
                <div className="mx-[10px] px-6 mt-2">
                    <TasksListSkeleton />
                </div>
            </div>
        </div>
    )
}

export default MyTaskWidgetSkeleton
